import { render, staticRenderFns } from "./GroupMemberIcon.vue?vue&type=template&id=5cdaa41a"
import script from "./GroupMemberIcon.vue?vue&type=script&lang=js"
export * from "./GroupMemberIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports